module.exports = __webpack_public_path__ + "static/img/human-3.9d421716.png";